import React__default from 'react';
import '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import { getFocusables } from '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import ReactFocusLock from 'react-focus-lock';

/**
 * React component to trap focus within an element or component.
 * Mostly used in Modals, Popovers, etc.
 */

function FocusLock(props) {
  var initialFocusRef = props.initialFocusRef,
      finalFocusRef = props.finalFocusRef,
      contentRef = props.contentRef,
      restoreFocus = props.restoreFocus,
      children = props.children,
      disabled = props.disabled,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus;
  var onActivation = React__default.useCallback(function () {
    if (initialFocusRef == null ? void 0 : initialFocusRef.current) {
      initialFocusRef.current.focus();
    } else {
      if (!(contentRef == null ? void 0 : contentRef.current)) {
        return;
      }

      var focusables = getFocusables(contentRef.current);

      if (contentRef.current && !focusables.length) {
        var _contentRef$current;

        (_contentRef$current = contentRef.current) == null ? void 0 : _contentRef$current.focus();
      }
    }
  }, [initialFocusRef, contentRef]);
  var onDeactivation = React__default.useCallback(function () {
    var _finalFocusRef$curren;

    finalFocusRef == null ? void 0 : (_finalFocusRef$curren = finalFocusRef.current) == null ? void 0 : _finalFocusRef$curren.focus();
  }, [finalFocusRef]);
  var returnFocus = restoreFocus && !finalFocusRef;
  return React__default.createElement(ReactFocusLock, {
    autoFocus: autoFocus,
    disabled: disabled,
    onActivation: onActivation,
    onDeactivation: onDeactivation,
    returnFocus: returnFocus
  }, children);
}

export default FocusLock;
//# sourceMappingURL=index.esm.js.map
